<template>
  <!-- menu with submenu -->
  <li v-if="menu.children" class="has-sub"
    v-bind:class="{ active: subIsActive(menu.path), expand: this.stat == 'expand' }">
    <a href="#" v-on:click.prevent.stop="expand($event)" @mouseover="mouseOver(menu.children, $event)"
      @mouseleave="hideFloatSubmenu">
      <i v-if="menu.icon" v-bind:class="menu.icon"></i>
      <div v-if="menu.img" class="icon-img"><img v-bind:src="menu.img" alt="" /></div>
      <span class="menu-title">
        {{ menu.title }}
        <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
        <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"></i>
      </span>
      <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
      <img v-else class="caret"
        :class="{ 'caret-rotated': menu.title === 'Activities' && menu.title === 'Domain Detection' }"
        src="@/assets/img/multiselect-chevron.svg" alt="caret icon" />
    </a>
    <ul class="sub-menu" v-bind:class="{ 'd-block': this.stat == 'expand', 'd-none': this.stat == 'collapse' }"
      v-bind:style="{ marginTop: pageOptions.pageSidebarMinified ? -(scrollTop + 40) + 'px' : '' }">
      <sidebar-nav-list v-for="submenu in menu.children" v-bind:key="submenu.path" v-bind:menu="submenu" ref="sidebarNavList"
        v-on:calcFloatSubmenu="handleCalcFloatSubmenu"
        v-on:collapse-other="handleCollapseOther(submenu)"></sidebar-nav-list>
    </ul>
  </li>

  <!-- menu without submenu -->
  <!-- <router-link v-else v-bind:to="{ path: menu.path, force: true }" active-class="active" tag="li"
    v-on:click.native="collapseOther(menu.path)" class="mt-2"> -->
  <router-link v-else v-bind:to="{ path: menu.path, force: true }" active-class="active" exact tag="li"
    v-on:click.native="collapseOther(menu.path)" class="mt-2">
    <a>
      <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
      <i v-if="menu.icon" v-bind:class="menu.icon"></i>
      <div v-if="menu.img" class="icon-img"><img v-bind:src="menu.img" alt="" /></div>
      <span>
        {{ menu.title }}
        <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"></i>
        <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
      </span>
    </a>
  </router-link>
</template>

<script>
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions.js";

export default {
  name: "SidebarNavList",
  props: ["menu", "scrollTop"],
  components: {
    SidebarNavList,
  },
  data() {
    return {
      stat: "",
      pageOptions: PageOptions,
      currentPath: this.$route.path,
    };
  },
  watch: {
    "$route.path": {
      handler: function (newPath) {
        // Automatically expand menu if a submenu is active
        if (this.menu.children && this.subIsActive(this.menu.path)) {
          this.stat = "expand";
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // Set initial expand state if a submenu is active
    if (this.menu.children && this.subIsActive(this.menu.path)) {
      this.stat = "expand";
    }
  },
  methods: {
    mouseOver: function (data, event) {
      if (this.pageOptions.pageSidebarMinified) {
        var offset = event.target.offsetParent.getBoundingClientRect();
        this.$emit("showFloatSubmenu", data, offset);
      }
    },
    hideFloatSubmenu: function () {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit("hideFloatSubmenu");
      }
    },
    expand: function () {
      if (this.stat == "") {
        this.stat = this.subIsActive(this.menu.path) ? "expand" : "expand";
      } else {
        // Don't allow collapsing if a submenu is active
        if (this.stat == "expand" && this.subIsActive(this.menu.path)) {
          return; // Keep expanded if submenu is active
        }
        this.stat = this.stat == "expand" ? "collapse" : "expand";
      }
      this.$emit("collapse-other", this.menu);

      if (this.pageOptions.pageSidebarMinified) {
        this.$emit("calcFloatSubmenu");
      }
    },
    handleCalcFloatSubmenu: function () {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit("calcFloatSubmenu");
      }
    },
    collapse: function (menu) {
      if (this.menu != menu) {
        this.stat = "collapse";
      }
    },
    collapseOther: function (path) {
      this.$emit("collapse-other", this.menu);

      console.log(this.currentPath, path);
      if (this.currentPath == path) this.$router.go(0);
      // console.log('reload')
      else {
        this.currentPath = path;
      }
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.menu.children.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    subIsActive(path) {
      const paths = Array.isArray(path) ? path : [path];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0;
      });
    },
  },
};
</script>

<style scoped>
.icon-img {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: visible;
  padding: 0;
  margin: 0;
  line-height: 0;
}

.icon-img img {
  width: 16px;
  height: 16px;
  max-width: 16px;
  max-height: 16px;
  display: block;
  object-fit: contain;
  object-position: center;
  transition: filter 0.2s ease;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}

/* Inactive state - gray color (#BEBEBE) */
.icon-img img {
  filter: brightness(0) saturate(100%) invert(82%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%);
}

/* Active state - red color (#CD2E2C) */
li.active .icon-img img,
.has-sub.active .icon-img img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg) brightness(85%) contrast(96%) !important;
}

/* Hover state - red color (#CD2E2C) */
li:hover:not(.active) .icon-img img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg) brightness(85%) contrast(96%);
}

/* Active hover state - keep red (#CD2E2C) */
li.active:hover .icon-img img,
.has-sub.active:hover .icon-img img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg) brightness(85%) contrast(96%) !important;
}

/* Menu text color - Inactive (#BEBEBE) */
li>a {
  color: #bebebe !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
}

/* Menu text color - Active (#CD2E2C) */
li.active>a,
li.active>a span,
.has-sub.active>a,
.has-sub.active>a span {
  color: #cd2e2c !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
}

/* Menu text color - Hover (#CD2E2C) */
li:hover:not(.active)>a,
li:hover:not(.active)>a span {
  color: #cd2e2c !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
}

/* Active hover state - keep red (#CD2E2C) */
li.active:hover>a,
li.active:hover>a span,
.has-sub.active:hover>a,
.has-sub.active:hover>a span {
  color: #cd2e2c !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 12px !important;
}

/* Rotate Activities menu chevron 90 degrees counterclockwise when collapsed */
.caret-rotated {
  transform: rotate(-90deg);
  transition: transform 0.3s ease;
}

/* Rotate Activities menu chevron to 0 degrees when expanded or when a submenu is active */
.has-sub.expand .caret-rotated,
.has-sub.active .caret-rotated {
  transform: rotate(0deg);
}

.sub-menu .icon-img {
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  overflow: visible;
  padding: 0;
  margin: 0;
  line-height: 0;
}

.sub-menu .icon-img img {
  width: 10px;
  height: 10px;
  max-width: 10px;
  max-height: 10px;
  display: block;
  object-fit: contain;
  object-position: center;
  transition: filter 0.2s ease;
  margin: 0;
  padding: 0;
  vertical-align: middle;
}

.sub-menu li:hover .icon-img img {
  filter: brightness(0) saturate(100%) invert(19%) sepia(95%) saturate(4845%) hue-rotate(347deg) brightness(85%) contrast(96%) !important;
}
</style>
